<template lang="pug">
.modal-bg.rounded.h-full.items-center.content-center.justify-center(:class="{ hidden: !showModal, flex: showModal }")
  .modal.rounded-lg.shadow.-mt-6.p-8
    h1 ☝️
    p.text-lg.mt-2 Do you really want to cancel your subscription?
      br
      i.mt-2 You can access gootics until the end of the current billing period
    p.mt-3
      button.btn-secondary(@click="delSub()") Cancel subscription
    button.mt-3.btn.bg-transparent(@click="hideModal(); showModal=!showModal") Cancel
</template>

<script>
export default {
  props: {
    show: Boolean,
    delSub: Function,
    hideModal: Function
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    show: function (val) {
      console.log('watch: ' + val)
      this.showModal = val
    }
  }
}
</script>

<style>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.3);
}
.modal {
  margin: 0 auto;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ModalDel.vue